var typeOfTree;
var exclusive;
var exclusiveLink;
var showAll;
var loadMore;
var freeDelivery;
var mostSelling;
var questionBanner;
var detailInfo;
var similiarTree;
var copy;
var search;
var registrationLink;
var christmasCountDown;
var days;
var hours;
var minutes;
var basketBack;
var basketHeaderTitle;
var basketHeaderSummary;
var basketHeaderBtn;
var freeDeliveryExt;

var registrationBread;
var registrationTitle;
var registrationReg;
var registrationFB;
var registrationFBLink;
var registrationForgot;

var basketBacks;
var basketTitleUser;
var basketDelivery;
var basketPayment;
var basketReca;
var basketFinishTitle;
var basketAccount;
var basketInfoText;
var basketTitle;
var basketHeadAva;
var basketHeadQuan;
var basketHeadPrice;
var basketDiscountText;
var basketDiscountIns;
var basketdod;
var basketCompany;
var basketSuccessTitle;
var basketSuccessText;
var basketSuccessText2;
var basketSuccessHeaderStep1;
var basketSuccessHeaderStep2;
var basketSuccessHeaderStep3;
var basketSuccessHeaderStep4;

var productSugTitle;
var productSugText;
var productSugCon;

var freeDelText1;
var freeDelText2;
var freeDelText3;
var freeDelText4;

var addToBasket;

var categorySort;
var categoryRemove;
var categoryMore;
var categoryUsed;
var categoryTitle;

var detailCode;
var detailBack;

var sale;

var homeMoreAll;

var lang;

var categoryClose;
var categoryOpen;

var mail;
var langSk = false;
var langCs = false;

function componentLanguage() {
  if ($("html").attr("lang") == "sk") {
    lang = "sk";
    sale = "Výpredaj";
    mail = "info@tatratree.sk";
    typeOfTree = "ihličie";
    exclusive = "3D Exkluzívne";
    exclusiveLink = "3d-exkluzivne";
    showAll = "ZOBRAZIŤ VŠETKY";
    basketTitleUser = "Zákaznícke údaje";
    loadMore = "NAČÍTAŤ ĎALŠIE";
    freeDelivery = "doprava zadarmo";
    freeDeliveryExt = "Doprava zadarmo";
    mostSelling = "Najpredávanejšie";
    questionBanner = "Máte otázku? <br>Obraťte se na nás.";
    detailInfo = "Detailné informácie";
    similiarTree = "Podobné stromčeky";
    copy = "Všetky práva vyhradené";
    search = "Hľadať …";
    registrationLink = "/registracia";
    christmasCountDown = "DO VIANOC ZOSTÁVA";
    days = "Dní";
    hours = "Hodín";
    minutes = "Minút";
    basketHeaderTitle = "Obsah košíka";
    basketBack = "Návrat do obchodu";
    basketHeaderSummary = "Spolu";
    basketHeaderBtn = "PREJSŤ DO KOŠÍKA";
    registrationBread = "Prihlásenie - Registrácia";
    registrationTitle = "Prihlásenie";
    registrationReg = "ZAREGISTROVAŤ SA";
    registrationFB = "alebo sa prihlásiť cez sociálne siete";
    registrationFBLink =
      '<span class="d-none d-sm-block">Prihlásiť sa cez Facebook</span><span class="d-block d-sm-none">Prihlásiť sa</span>';
    registrationForgot = "Zabudli ste heslo?";
    basketBacks = "KROK späť";
    basketDelivery = "Spôsob dopravy";
    basketPayment = "Spôsob platby";
    basketReca = "Rekapitulácia objednávky";
    basketFinishTitle = "DOKONČIŤ OBJEDNÁVKU";
    basketAccount =
      "<span class='btn-in'> Máte už vytvorený účet? <strong>Prihlásiť sa</strong></span></span>";
    basketInfoText = "Informácie o Vás";
    basketTitle = "Nákupný košík";
    basketHeadAva = "Dostupnosť";
    basketHeadQuan = "Množstvo";
    basketHeadPrice = "Výsledná cena";
    basketDiscountText = "Zľavový kupón";
    basketDiscountIns = "UPLATNIŤ";
    basketdod = "Dodacie a fakturačné údaje";
    basketCompany = "Chcem nakupovať ako živnostník/firma";

    basketSuccessTitle = "Objednávka úspešne dokončená!";
    basketSuccessText = "O priebehu objednávky č.";
    basketSuccessText2 = "Vás budeme priebežne emailom informovať!";
    basketSuccessHeaderStep1 = "Nákupný košík";
    basketSuccessHeaderStep2 = "Platba a doprava";
    basketSuccessHeaderStep3 = "Informácie o Vás";
    basketSuccessHeaderStep4 = "Objednávka";
    productSugTitle = "Mohlo by Vás tiež zaujímať";
    productSugText = "PREJSŤ DO KOŠÍKA";
    productSugCon = "Pokračovať v nákupe";
    freeDelText1 =
      "Do <strong> dopravy zadarmo </strong> zostáva nakúpiť ešte za <strong>";
    freeDelText2 = "Dopravu máte zadarmo";
    freeDelText3 =
      '<div class="delivery-block-title"><strong>Získajte</strong> <span>DOPRAVU ZADARMO</span>, <br> pri nákupe nad 100€ </div>';
    freeDelText4 = "Do dopravy zadarmo zostáva nakúpiť ešte za <strong> ";
    addToBasket = "PRIDAŤ DO KOŠÍKA";

    categorySort = "Zoradiť podľa:";
    categoryRemove = "VYMAZAŤ VŠETKY FILTRE";
    categoryMore = "Podrobný filter";
    categoryUsed = "POUŽIT FILTRE";
    categoryTitle = "Ponuka stromčekov";
    categoryClose = "Zatvoriť";
    categoryOpen = "Otvoriť";

    homeMoreAll = "vsetky";

    detailCode = "KÓD PRODUKTU:";
    detailBack = "NÁVRAT DO PONUKY produktov";

    langSk = true;
  }

  if ($("html").attr("lang") == "cs") {
    $("body").css("opacity", 0);
    $("body").css("display", "none");
    $("body").css("visibility", "hidden");

    $("body").keypress(function (event) {
      if (event.keyCode == 116) {
        $("body").css("display", "block");
        $("body").css("opacity", 1);
        $("body").css("visibility", "visible");
      }
    });

    lang = "cz";
    sale = "Výprodej";
    mail = "info@tatratree.cz";
    basketTitleUser = "Zákaznické údaje";
    typeOfTree = "JEHLIČÍ";
    exclusive = "3D Exkluzivní";
    exclusiveLink = "3d-exkluzivni";
    showAll = "ZOBRAZIT VŠECHNY";
    loadMore = "NAČÍST VÍCE";
    freeDelivery = "doprava zdarma";
    freeDeliveryExt = "Doprava zdarma";
    mostSelling = "Nejprodávanější";
    questionBanner = "Máte otázku? <br> Obraťte se na nás.";
    detailInfo = "Detailní informace";
    similiarTree = "Podobné stromky";
    copy = "Všechna práva vyhrazena";
    search = "Hledat ...";
    registrationLink = "/registrace";
    christmasCountDown = "DO VÁNOC ZBÝVA";
    days = "Dní";
    hours = "Hodin";
    minutes = "Minut";
    categoryClose = "Zavřít";
    categoryOpen = "Otevřít";
    basketHeaderTitle = "Obsah košíku";
    basketHeaderSummary = "Celkem";
    basketHeaderBtn = "PŘEJÍT DO KOŠÍKU";
    registrationBread = "Přihlášení - Registrace";
    registrationTitle = "Přihlášení";
    registrationReg = "ZAREGISTROVAT SE";
    registrationFB = "nebo se přihlásit přes sociální sítě";
    registrationFBLink =
      '<span class="d-none d-sm-block"> Přihlásit se přes Facebook </span> <span class="d-block d-sm-none"> Přihlásit se </span>';
    registrationForgot = "Zapomněli jste heslo?";
    basketBack = "KROK zpět";
    basketBacks = "Zpět do obchodu";
    basketDelivery = "Způsob dopravy";
    basketPayment = "Způsob platby";
    basketReca = "Rekapitulace objednávky";
    basketFinishTitle = "DOKONČIT OBJEDNÁVKU";
    basketAccount =
      "<span class='btn-in'> Máte již účet? <strong> Přihlásit se </strong></span></span>";
    basketInfoText = "Informace o Vás";
    basketTitle = "Nákupní košík";
    basketHeadAva = "Dostupnost";
    basketHeadQuan = "Množství";
    basketHeadPrice = "Konečná cena";
    basketDiscountText = "Slevový kupón";
    basketDiscountIns = "UPLATNIT";
    basketdod = "Dodací a fakturační údaje";
    basketCompany = "Chci nakupovat jako živnostník / firma";
    basketSuccessTitle = "Objednávka úspěšně dokončena!";
    basketSuccessText = "O průběhu objednávky č.";
    basketSuccessText2 = "Vás budeme průběžně emailem informovat!";
    basketSuccessHeaderStep1 = "Nákupní košík";
    basketSuccessHeaderStep2 = "Platba a doprava";
    basketSuccessHeaderStep3 = "Informace o Vás";
    basketSuccessHeaderStep4 = "Objednávka";

    productSugTitle = "Mohlo by Vás také zajímat";
    productSugText = "PŘEJÍT DO KOŠÍKU";
    productSugCon = "Pokračovat v nákupu";

    freeDelText1 =
      "Do <strong> dopravy zdarma </strong> zbývá nakoupit ještě za <strong>";
    freeDelText2 = "Dopravu máte zdarma";
    freeDelText3 =
      '<div class="delivery-block-title"> <strong> Získejte </strong> <span> DOPRAVU ZDARMA </span>, <br> při nákupu nad 2500 Kč </div>';
    freeDelText4 = "Do dopravy zdarma zbývá nakoupit ještě za <strong>";

    addToBasket = "PŘIDAT DO KOŠÍKU";

    categorySort = "Řazení:";
    categoryRemove = "SMAZAT VŠECHNY FILTRY";
    categoryMore = "Podrobný filtr";
    categoryUsed = "Použité filtry";
    categoryTitle = "Nabídka stromků";
    homeMoreAll = "vsechny-stromy";
    detailCode = "KOD PRODUKTU:";
    detailBack = "Zpět DO NABÍDKY produktů";
    langCs = true;
  }
}
